import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { MOBILE_BREAKPOINT } from '../../../constants';
import { REALITY_CHECK_VALUES as RC_VALUES } from '../../../constants/casino';

import Button from '@xanadu/ui-shared/components/widgets/Button';

import styles from './CasinoRealityCheckModalContent.module.scss';

const CasinoRealityCheckModalContent = ({
  displayModal,
  updateCasinoRealityCheck,
  clearCasinoControlsErrors,
  getGameRealMode,
  editState,
  editError,
  gameId,
  widthSize,
  history,
}) => {
  const [minutes, setMinutes] = useState(5);

  const isMobile = widthSize <= MOBILE_BREAKPOINT;

  const handleClick = () => {
    const isClickable = editState !== 'success' && editState !== 'loading';
    if (isClickable) {
      updateCasinoRealityCheck({
        realityCheckMinutes: minutes,
      });
    }
  };

  const handleBack = () => {
    const path = history.location.pathname;
    const regex = new RegExp(`${gameId}`);
    const index = path.search(regex);
    const lobbyUrl = path.slice(0, index);
    displayModal({
      show: false,
    });
    clearCasinoControlsErrors();
    history.push(`${lobbyUrl}`);
  };

  useEffect(() => {
    let timer;

    if (editState === 'success') {
      timer = setTimeout(() => {
        displayModal({
          show: false,
        });
        clearCasinoControlsErrors();
        getGameRealMode(gameId);
      }, 1000);
    }

    return () => {
      clearTimeout(timer);
      timer = null;
    };
  }, [editState]);

  const getSelectedClass = (minutesValue) => classNames({
    [styles.selected]: minutes === minutesValue,
  });

  return (
    <div className={styles.main}>
      <div>
        <h2>Casino Reality Check</h2>
        <p>
          During your casino play, a reality check will appear to remind you of how
          long you have been playing.
          You may then choose to continue playing, or exit the game.
        </p>
        <p>
          Prior to playing, you must select an interval for how often
          the reality check will be shown.
        </p>
        <b>Select a time period:</b>
        <div className={styles.grid}>
          {RC_VALUES.map((value) => (
            <div
              role="button"
              onClick={() => setMinutes(value)}
              className={getSelectedClass(value)}
            >
              {value} mins
            </div>
          ))}
        </div>
        {editState === 'error' && (
          <div className={styles.errorContainer}>
            {editError || 'There was a problem launching the game'}
          </div>
        )}
      </div>
      <div className={styles.containerActions}>
        <Button
          sizeType={isMobile ? 'wider' : 'wide'}
          buttonType="primary"
          onClick={handleClick}
          loading={editState === 'loading'}
          success={editState === 'success'}
        >
          {editState === 'error' ?
            'try again'
            :
            'set reality check'
          }
        </Button>
        {editState === 'error' && (
          <Button
            sizeType={isMobile ? 'wider' : 'wide'}
            buttonType="flat"
            onClick={handleBack}
          >
            back to lobby
          </Button>
        )}
      </div>
    </div>
  );
};

CasinoRealityCheckModalContent.propTypes = {
  displayModal: PropTypes.func.isRequired,
  updateCasinoRealityCheck: PropTypes.func.isRequired,
  clearCasinoControlsErrors: PropTypes.func.isRequired,
  getGameRealMode: PropTypes.func.isRequired,
  editState: PropTypes.string,
  editError: PropTypes.string,
  gameId: PropTypes.string.isRequired,
  widthSize: PropTypes.number.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
  }),
};

export default CasinoRealityCheckModalContent;
